<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-space-between align-center mb-7">
      <div>
        <div style="font-size: 30px; font-weight: 800">
          Student Requirements
        </div>
        <div class="text-subtitle-2 mt-1">
          <span class="text-grey"
            >Manage requirements students need to submit</span
          >
        </div>
      </div>
      <v-btn
        color="#00A63E"
        class="white--text"
        @click="addnew"
        prepend-icon="mdi-plus"
        rounded="lg"
        size="large"
      >
        {{ tab == 1 ? "Add Requirement" : "Add Submission" }}
      </v-btn>
    </div>

    <!-- Search bar -->
    <v-card flat class="pa-4 rounded-xl mb-5 search-card">
      <v-row>
        <v-col cols="6" class="flex-items mt-2">
          <v-tabs v-model="activeTab" color="#00A63E" align-tabs="left">
            <v-tab
              v-for="tab in tabList"
              :value="tab.name"
              :key="tab.id"
              @click="changeTab(tab)"
              >{{ tab.name }}</v-tab
            >
          </v-tabs>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="search"
            placeholder="Search requirements..."
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="compact"
            hide-details
            clearable
          />
        </v-col>
      </v-row>
    </v-card>

    <!-- Data Table -->
    <v-card flat class="rounded-xl table-card">
      <v-data-table
        :headers="headers"
        :items="data"
        :search="search"
        :loading="loading"
        hover
        class="rounded-xl"
      >
        <template v-slot:[`item.programs`]="{ item }">
          <div class="d-flex flex-wrap ga-1 py-2">
            <v-chip
              v-for="i in item.programs"
              :key="i.id"
              size="x-small"
              variant="tonal"
              color="green"
              >{{ i.abbr }}</v-chip
            >
          </div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            size="small"
            color="#00A63E"
            variant="tonal"
            prepend-icon="mdi-pencil-outline"
            rounded="lg"
            @click="editItem(item)"
          >
            Edit
          </v-btn>
        </template>

        <template #no-data>
          <div class="text-center py-8 text-grey">No requirements found.</div>
        </template>
      </v-data-table>
    </v-card>

    <!-- Dialogs -->
    <StudentRequirementsDialog
      :data="itemData"
      :action="action"
      title="Student Requirement"
      :typeToSave="tab == 1 ? 'requirements' : 'student_submission'"
    />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import StudentRequirementsDialog from "../Dialogs/Forms/StudentRequirementsDialog.vue";
export default {
  components: {
    StudentRequirementsDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    search: "",
    headers: [
      { title: "Name", value: "name", align: "start" },
      { title: "Program", value: "programs", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "OJT Requirements" },
    tab: 1,
    tabList: [
      { id: 1, name: "OJT Requirements" },
      { id: 2, name: "OJT Submissions" },
    ],
    totalCount: 0,
    deleteData: null,
    itemData: null,
    uploadData: null,
    alerted: false,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    work_dates_menu: false,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    eventBus.on("closeStudentRequirementsDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeStudentRequirementsDialog");
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      this.loading = true;
      if (this.tab == 1) {
        this.axiosCall(
          "/student-requirement/my_handled_programs?type=requirements",
          "GET",
        ).then((res) => {
          if (res) {
            this.data = Array.isArray(res.data) ? res.data : [];
            this.loading = false;
          }
        });
      } else {
        this.axiosCall(
          "/student-requirement/my_handled_programs?type=student_submission",
          "GET",
        ).then((res) => {
          if (res) {
            this.data = Array.isArray(res.data) ? res.data : [];
            this.loading = false;
          }
        });
      }
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },
    upload() {
      this.uploadData = { id: null };
      this.action = "Add";
    },
    deleteItem(item) {
      console.log(item);
      this.alerted = true;
      // this.dialogConfirmDelete = true;
      // this.deleteData = item;
    },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },
    changeTab(tab) {
      this.activeTab = tab.name;
      this.tab = tab.id;
      this.initialize();
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.search-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
.table-card {
  border: 1px solid #d1d5db !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
</style>
